module.exports = __webpack_public_path__ + "media/images/ui-bg_inset-soft_95_fef1ec_1x100-8590e8e6c045e77bdad0ad5ca1d35a3e.png";